/*
 * @Author: your name
 * @Date: 2021-04-30 11:21:00
 * @LastEditTime: 2021-06-07 11:06:06
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \leading\newVersionEdingzi\src\store\index.js
 */
import Vue from 'vue'
import Vuex from 'vuex';
import login from './modules/login'
import orderList from './modules/orderList'
import { config } from '../api/index'
Vue.use(Vuex);
//时间格式
Vue.directive('time', {
    bind: function(el, binding) {
        var getTime = new Date(binding.value.replace(/-/g, "/"))
        var month = getTime.getMonth() + 1;
        var date = getTime.getDate();
        month <= 9 ? (month = '0' + month) : month;
        date <= 9 ? (date = '0' + date) : date;
        el.innerHTML = `${getTime.getFullYear()}-${month}-${date}`;
    }
})

const store = new Vuex.Store({
    state: {
        keepAlive: [], //缓存的页面
        baseURL: config.baseURL,
        isExistNum: Number,
        newDate: 0, //当前准确时间
        newDateValue: "", //当前时间
        newDateInterval: "", //定时器
    },
    mutations: {
        //显式的更改state里的数据
        changeIsExistNum(state, dta) {
            state.isExistNum = dta;
        },
        // //获取时间后执行定时器
        // turnoverTime(state) {
        //     clearInterval(state.newDateInterval);
        //     state.newDateInterval = setInterval(_ => {
        //         state.newDate += 1000;
        //         state.newDateValue = Vue.prototype.U.timestamp(state.newDate).YTDhms;
        //     }, 1000);
        // },
        //关闭定时器
        clearTurnoverTime(state) {
            state.newDate = 0;
            clearInterval(state.newDateInterval);
        },
        'SET_KEEPALIVE': (state, list) => {
            state.keepAlive = list
        },
    },
    actions: {
        // turnoverTimeActions (context) {
        //     context.commit('turnoverTime')
        // },
        clearIntervalTurnoverTime(context) {
            context.commit('clearTurnoverTime')
        },
        // 添加缓存的页面
        addKeepAlive({ commit, state }, name) {
            let alive = new Set(state.keepAlive)
            if(alive.has(name)) return;
            alive.add(name);
            let list = [...alive];
            commit('SET_KEEPALIVE', list)
        },
        // 设置缓存的页面
        setKeepAlive({ commit }, list) {
            if(!list) return;
            if(typeof list === 'string') {
            list = JSON.parse(list)
            }
            commit('SET_KEEPALIVE', list)
        },
        // 清除缓存的页面
        removeKeepAlive({ commit }) {
            commit('SET_KEEPALIVE', [])
        }
    },
    modules: {
        login,
        orderList
    }
});
export default store


// WEBPACK FOOTER //
// ./src/store/index.js